import type { I18N } from '@vista-digital/i18n'
import type { OrderItemLine, Site } from '@vista-digital/ocapi-types/v1'
import { Ecommerce } from '../models-gtm'
import { getConcessionCartItems } from './getConcessionCartItems'
import { getDedupedCartItems } from './getDedupedCartItems'

export const getConcessionPaymentEcommerceModel = (
    concessions: OrderItemLine[],
    site: Site,
    i18n: I18N,
    value?: number,
    transactionId?: string,
    vistaTransactionId?: number
): Ecommerce => {
    const cartItems = getConcessionCartItems(concessions, site, i18n)
    const dedupedCartItems = getDedupedCartItems(cartItems)

    return new Ecommerce(dedupedCartItems, value, transactionId, vistaTransactionId)
}
